export default __webpack_public_path__ + "static/media/know-total.c9aa4566.webp";